<script>
    import blockAdBlock from 'blockadblock'

    export default {
        data() {
            return {
                show: false,
            }
        },
        methods: {
            onDetected() {
                this.show = true;
            }
        },
        mounted() {

            if('blockAdBlock' in window && typeof blockAdBlock === 'object'){

                window.blockAdBlock.on(true, this.onDetected);

            }

        },
    }
</script>
<template>
    <div v-if="show" class="notification" v-html="$t('lang.main.ad_block_html')"></div>
</template>

<style scoped>

    .notification {
        max-width: 1500px;
        min-width: 1100px;
        line-height: 21px;
        font-size: 16px;
        padding: 7px 18px 9px;
        margin: 5px auto;
        border: 1px solid #f2ab99;
        border-radius: 2px;
        background: #ffefe9;
    }

</style>